import { GetWallet } from '../contracts';
import axios, { AxiosError } from 'axios';
import { createAxiosConfig } from '../apiHelpers';
import LogCannon from '@ace-clublabs/log-cannon';
import StatusCode from 'status-code-enum';

export const GetAppleWalletApi =
  (endpoint: string): GetWallet =>
  async () => {
    try {
      const config = { ...createAxiosConfig(endpoint) };
      const response = await axios.post(endpoint, {}, config);

      LogCannon.blast('Apple Wallet success');
      return Promise.resolve(response.data);
    } catch (e: any | AxiosError) {
      if (e.message === '') {
        return Promise.resolve({ status: 'cancel' });
      }

      const errorResponse = e?.response?.data?.error;
      LogCannon.blast('Apple Wallet error', errorResponse);
      return Promise.resolve({
        status: 'error',
        error: {
          code: e?.response?.status || StatusCode.ServerErrorInternal,
          message: 'Request Apple Wallet failed',
          ...errorResponse,
        },
      });
    }
  };

export const GetAndroidWalletApi =
  (endpoint: string): GetWallet =>
  async () => {
    try {
      const config = { ...createAxiosConfig(endpoint) };
      const response = await axios.post(endpoint, {}, config);

      LogCannon.blast('Android Wallet success');
      return Promise.resolve(response.data);
    } catch (e: any | AxiosError) {
      if (e.message === '') {
        return Promise.resolve({ status: 'cancel' });
      }

      const errorResponse = e?.response?.data?.error;
      LogCannon.blast('Android Wallet error', errorResponse);
      return Promise.resolve({
        status: 'error',
        error: {
          code: e?.response?.status || StatusCode.ServerErrorInternal,
          message: 'Request Android Wallet failed',
          ...errorResponse,
        },
      });
    }
  };
